import cobol from "refractor/cobol";
export default cobol;